var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 22V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587Q22 3.176 22 4v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18H6zm3.15-6H20V4H4v13.125z"
}))));
export { SvgCommentIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzI1NDhfNDU1OTEiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjU0OF80NTU5MSkiPgo8cGF0aCBkPSJNMiAyMlY0QzIgMy40NSAyLjE5NTgzIDIuOTc5MTcgMi41ODc1IDIuNTg3NUMyLjk3OTE3IDIuMTk1ODMgMy40NSAyIDQgMkgyMEMyMC41NSAyIDIxLjAyMDggMi4xOTU4MyAyMS40MTI1IDIuNTg3NUMyMS44MDQyIDIuOTc5MTcgMjIgMy40NSAyMiA0VjE2QzIyIDE2LjU1IDIxLjgwNDIgMTcuMDIwOCAyMS40MTI1IDE3LjQxMjVDMjEuMDIwOCAxNy44MDQyIDIwLjU1IDE4IDIwIDE4SDZMMiAyMlpNNS4xNSAxNkgyMFY0SDRWMTcuMTI1TDUuMTUgMTZaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=";